export default [
  {
    path: '/admin/licenses',
    name: 'Licences',
    component: () => import('@/views/Admin/Licenses/Index.vue'),
    meta: {
      pageTitle: 'Lisans Yönetimi',
      breadcrumb: [
        {
          text: 'Listele',
          active: true,
        },
      ],
      resource: 'ADMIN_LICENCES',
      action: 'read',
    },
  },
  {
    path: '/admin/licenses/search',
    name: 'LicencesAdd',
    component: () => import('@/views/Admin/Licenses/Search.vue'),
    meta: {
      pageTitle: 'Lisans Yönetimi',
      breadcrumb: [
        {
          text: 'Listele',
          to: '/admin/licenses',
          active: false,
        },
        {
          text: 'Firma Ara',
          active: true,
        },
      ],
      resource: 'ADMIN_LICENCES_ADD',
      action: 'read',
    },
  },
  {
    path: '/admin/licenses/add/:id_customers',
    name: 'LicenceAdd',
    component: () => import('@/views/Admin/Licenses/Add.vue'),
    meta: {
      pageTitle: 'Lisans Yönetimi',
      breadcrumb: [
        {
          text: 'Listele',
          to: '/admin/licenses',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_LICENCES_ADD',
      action: 'read',
    },
  },
  {
    path: '/admin/licenses/edit/:id',
    name: 'LicencesEdit',
    component: () => import('@/views/Admin/Licenses/Edit.vue'),
    meta: {
      pageTitle: 'Lisans Yönetimi',
      breadcrumb: [
        {
          text: 'Listele',
          to: '/admin/licenses',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_LICENCES_EDIT',
      action: 'read',
    },
  },
]
